import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import AlertDismissible from '../../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../../Shared/Components/Breadcrumbs'
import Layout from '../../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const CatalogIndex = ({ items, filters, slug, typeLabel }) => {
    const { flash } = usePage().props
    const data = items.data
    const [deleteTarget, setDeleteTarget] = useState(null)
    const [deleting, setDeleting] = useState(false)

    const filterForm = useForm({
        search: filters.search || '',
    })

    const listPath = `admin/sia/manage/reclutamiento/catalogos/${slug}`

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('recruitment.catalogs.index', slug), { preserveState: true })
    }

    const clearFilters = () => {
        filterForm.setData({ search: '' })
        filterForm.get(route('recruitment.catalogs.index', slug))
    }

    const confirmDelete = () => {
        if (!deleteTarget) return
        setDeleting(true)
        Inertia.delete(route('recruitment.catalogs.destroy', [slug, deleteTarget.id]), {
            preserveScroll: true,
            onFinish: () => {
                setDeleting(false)
                setDeleteTarget(null)
            },
        })
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={listPath} />
            </span>

            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Reclutamiento — {typeLabel}</span>
                    </h3>
                    <div className="card-toolbar">
                        <Link href={route('recruitment.catalogs.create', slug)} className="btn btn-sm btn-primary">
                            Nuevo
                        </Link>
                    </div>
                </div>

                <div className="card-body pt-6">
                    <Form onSubmit={submitFilters} className="d-flex flex-wrap align-items-end gap-3 mb-8">
                        <div className="flex-grow-1" style={{ minWidth: '220px', maxWidth: '420px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Buscar</label>
                            <Form.Control
                                type="search"
                                className="form-control form-control-sm form-control-solid"
                                placeholder="Nombre…"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                            />
                        </div>
                        <Button type="submit" size="sm" variant="primary" disabled={filterForm.processing}>
                            Buscar
                        </Button>
                        <Button type="button" size="sm" variant="light" onClick={clearFilters}>
                            Limpiar
                        </Button>
                    </Form>

                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold text-muted text-uppercase fs-7 bg-light">
                                    <th className="min-w-80px ps-4 rounded-start">Orden</th>
                                    <th className="min-w-250px">Nombre</th>
                                    <th className="min-w-100px">Activo</th>
                                    <th className="min-w-120px text-end pe-4 rounded-end">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 && (
                                    <tr>
                                        <td className="text-center py-10 text-gray-700" colSpan={4}>
                                            No hay registros.
                                        </td>
                                    </tr>
                                )}
                                {data.map((row) => (
                                    <tr key={row.id}>
                                        <td className="ps-4">{row.sort_order}</td>
                                        <td className="text-uppercase fw-semibold text-gray-800">{row.name}</td>
                                        <td>{row.activo ? 'Sí' : 'No'}</td>
                                        <td className="text-end pe-4">
                                            <Link
                                                href={route('recruitment.catalogs.edit', [slug, row.id])}
                                                className="btn btn-sm btn-light-primary me-2"
                                            >
                                                Editar
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light-danger"
                                                onClick={() => setDeleteTarget(row)}
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={items.links} filters={{ search: filters.search || undefined }} />
                    </div>
                </div>
            </div>

            <Modal show={deleteTarget !== null} onHide={() => !deleting && setDeleteTarget(null)} centered>
                <Modal.Header closeButton={!deleting}>
                    <Modal.Title>Confirmar eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Eliminar <strong>{deleteTarget?.name}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" disabled={deleting} onClick={() => setDeleteTarget(null)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" disabled={deleting} onClick={confirmDelete}>
                        {deleting ? 'Eliminando…' : 'Eliminar'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Row>
    )
}

CatalogIndex.layout = (page) => <Layout title={`Catálogo — ${page.props.typeLabel}`}>{page}</Layout>

export default CatalogIndex
